export default function FormSelect({ label, error, required, children, className = '', ...props }) {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-slate-700 mb-1">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <select
                className={`w-full rounded-xl border border-slate-200 text-sm text-slate-800 focus:border-emerald-700 focus:ring-2 focus:ring-emerald-700/20 transition px-4 py-2.5 ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20' : ''}`}
                {...props}
            >
                {children}
            </select>
            {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
        </div>
    );
}
